import { PRICING_KEYS } from './steps/pricing-step';

// État de formulaire partagé par l'assistant de création et la fiche d'un
// client existant.

// MySQL renvoie les tinyint en 0 / 1 ; un booléen est accepté aussi.
export const isFlagEnabled = (value) => value === 1 || value === true;

export const toInformation = (client) => ({
  name: client.name || '',
  siret: client.siret || '',
  tva: client.tva || '',
  street: client.street || '',
  zipcode: client.zipcode || '',
  city: client.city || '',
  country: client.country || '',
  is_email_sending_enabled: isFlagEnabled(client.is_email_sending_enabled),
  is_sms_sending_enabled: isFlagEnabled(client.is_sms_sending_enabled),
});

/**
 * Données envoyées à l'API. Sert aussi de base de comparaison avant / après
 * pour un client existant.
 */
export const toClientPayload = ({ information, featuresV2, pricing }) => ({
  ...information,
  features_v2: featuresV2,
  // Les montants invalides sont déjà bloqués par isPricingValid : le filtre
  // ne fait que garantir qu'aucun NaN ne part vers l'API.
  pricing: Object.fromEntries(
    PRICING_KEYS.map((key) => [key, pricing?.[key]])
      .filter(([, value]) => value != null && value !== '')
      .map(([key, value]) => [key, Number(value)])
      .filter(([, value]) => Number.isFinite(value))
  ),
});

/**
 * Clients proposés comme modèle (« Partir d'un client existant »), triés par
 * identifiant.
 */
export const toClientsOptions = (clients, excludedClientId = null) =>
  (clients || [])
    .filter((client) => client.client_id !== excludedClientId)
    .sort((a, b) => a.client_id - b.client_id)
    .map((client) => ({
      value: String(client.client_id),
      name: `${client.client_id} - ${client.name}`,
    }));
